<template>
  <div
    class="d-flex justify-end mt-5"
    :class="$root.isMobile ? 'flex-column' : ''"
  >
    <v-btn
      depressed
      tile
      outlined
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/car-make-unlocking')"
    >
      Close
    </v-btn>
    <template v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher">
      <v-btn
        depressed
        tile
        outlined
        v-if="isUpdate && isAdmin"
        color="error"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="confirm = true"
      >
        Delete
      </v-btn>
      <v-btn
        depressed
        tile
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit(isUpdate ? 'update' : 'save')"
      >
        Submit
      </v-btn>
    </template>

    <Confirm
      :message="message"
      v-if="confirm"
      @close="confirm = false"
      @click="remove()"
    ></Confirm>
  </div>
</template>

<script>
import Confirm from "../../Confirm";
import { carMakeUnlocking } from "../../../assets/js/firebase";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    Confirm
  },
  data() {
    return {
      confirm: false,
      message: "Are you sure you want to delete this car make?"
    };
  },
  computed: {
    isUpdate() {
      return this.$route.name === "car-make-unlocking-update";
    }
  },
  methods: {
    async remove() {
      const vm = this;
      try {
        vm.$root.loader = true;
        let { id } = vm.$route.params;
        await carMakeUnlocking.doc(id).delete();
        vm.$router.replace("/car-make-unlocking");
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    }
  }
};
</script>
<style></style>
